import axios from '@/plugins/axios'

const getCreditCards = async () => {
  try {
    const response = await axios.get('credit-cards')
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const create = async ({
  number,
  holderName,
  expirationDate,
  cvv,
  street,
  streetNumber,
  neighborhood,
  complement,
  zipcode,
  city,
  state
}) => {
  try {
    const params = {
      holder_name: holderName,
      number: number,
      expiration_date: expirationDate,
      cvv: cvv,
      address: {
        street: street,
        number: streetNumber,
        neighborhood: neighborhood,
        complement: complement,
        zipcode: zipcode,
        city: city,
        state: state
      }
    }
    const response = await axios.post('credit-cards', params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const destroy = async (id) => {
  try {
    const response = await axios.post(`credit-cards/${id}`, {
      _method: 'DELETE'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const turnPrimary = async (id) => {
  try {
    const response = await axios.post(`credit-cards/${id}/primary`, {
      _method: 'PUT'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  create,
  destroy,
  getCreditCards,
  turnPrimary
}
